import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormCertificatesAnpr } from './types';

export const transformDataset = (values: FiltersFormCertificatesAnpr): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codicePostazioneAnpr: {
      value: otherValues.code || '',
      operation: Operation.EQUALS,
    },
    alias: { value: otherValues.alias || '', operation: Operation.LIKE },
    rilascioDal: {
      value: otherValues.startValidityDate?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    rilascioAl: {
      value: otherValues.endValidityDate?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    codicePostazioneAnpr: ordersToTransform.codeAnpr,
    alias: ordersToTransform.alias,
    rilascioDal: ordersToTransform.startValidityDate,
    rilascioAl: ordersToTransform.endValidityDate,
    operatoreUltimaModifica: ordersToTransform.lastOperator,
    codiceOperatoreAnpr: ordersToTransform.operatorCode,
    nomeOperatoreAnpr: ordersToTransform.operatorName,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
